import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField } from '@material-ui/core';

type SetCardCustomSizeDialogProps = {
  open: boolean;
  onClose: () => void;
  changeCardSize: (size: { width: number; height: number; }) => void;
}
const SetCardCustomSizeDialog: React.FC<SetCardCustomSizeDialogProps> = ({open, onClose, changeCardSize}) => {
  const [width, setWidth] = useState<number>();
  const [height, setHeight] = useState<number>();

  const updateCardSize = () => {
    if (!width || !height) return;
    changeCardSize({ width, height });
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>カスタムサイズを設定します</DialogTitle>
      <DialogContent style={{ overflow: 'hidden' }}>
        <TextField variant="outlined" fullWidth label="幅" type="number"
          value={width} onChange={(ev) => setWidth(Number(ev.currentTarget.value))}
          style={{ marginBottom: 16 }}
        />
        <TextField variant="outlined" fullWidth label="高さ" type="number"
          value={height} onChange={(ev) => setHeight(Number(ev.currentTarget.value))}
        />
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={updateCardSize} disabled={!width || !height}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SetCardCustomSizeDialog;
